import type { FeatureContext } from '../../types';
import { formatDate } from '../../shared/formatters';

import './sample-data.css';

export function SampleDataFeature({ items, itemsLoading, itemsError }: FeatureContext) {
  const showEmptyState = !itemsLoading && items.length === 0 && !itemsError;

  return (
    <section className="page-section sample-data">
      <h2>Sample Items</h2>
      {items.length > 0 ? (
        <ul className="sample-data__list">
          {items.map((item) => (
            <li key={item.id} className="sample-data__item">
              <strong className="sample-data__item-name">{item.name}</strong>
              <small className="sample-data__item-meta">Created {formatDate(item.created_at)}</small>
            </li>
          ))}
        </ul>
      ) : showEmptyState ? (
        <p className="sample-data__placeholder">No items found yet. Create seed data with Alembic migrations.</p>
      ) : itemsLoading ? (
        <p className="sample-data__placeholder">Loading sample data…</p>
      ) : itemsError ? (
        <p className="sample-data__placeholder" role="status">
          Unable to show sample data until the backend call succeeds.
        </p>
      ) : (
        <p className="sample-data__placeholder">Sample data will appear once the backend returns items.</p>
      )}
    </section>
  );
}
